import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import IntroOverlay from "@/components/IntroOverlay";
import Hero from "@/pages/sections/Hero";
import EditorialMarquee from "@/pages/sections/Marquee";
import GlobalBand from "@/pages/sections/GlobalBand";
import Platform from "@/pages/sections/Platform";
import Solutions from "@/pages/sections/Solutions";
import MapShowcase from "@/pages/sections/MapShowcase";
import PortsFlight from "@/pages/sections/PortsFlight";
import Manifesto from "@/pages/sections/Manifesto";
import Pricing from "@/pages/sections/Pricing";
import DemoSection from "@/pages/sections/DemoSection";

export default function Landing() {
  const [intro, setIntro] = useState(
    () => typeof window !== "undefined" && sessionStorage.getItem("arjuna_intro") !== "done"
  );

  useEffect(() => {
    if (!intro) return;
    document.body.style.overflow = "hidden";
    const timer = setTimeout(() => {
      sessionStorage.setItem("arjuna_intro", "done");
      setIntro(false);
    }, 5000);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, [intro]);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: true }}>
      <AnimatePresence>{intro && <IntroOverlay key="intro" />}</AnimatePresence>
      <div className="relative bg-arjuna-ink" data-testid="landing-page">
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <GlobalBand />
          <Platform />
          <Solutions />
          <MapShowcase />
          <PortsFlight />
          <Manifesto />
          <Pricing />
          <DemoSection />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
